import { resolveLandingRoute } from '@/lib/roles'

const LAST_ROUTE_KEY = 'nexus.lastRoute'

const EXACT_EXCLUDED = new Set([
  '/login',
  '/self-referral',
  '/cso-intake',
  '/access-denied',
])

const EXCLUDED_PREFIXES = ['/intake/']

const KNOWN_ROUTE_PATTERNS: RegExp[] = [
  /^\/$/,
  /^\/referrals$/,
  /^\/referrals\/new$/,
  /^\/referrals\/[^/]+$/,
  /^\/approvals$/,
  /^\/approvals\/[^/]+$/,
  /^\/profile$/,
  /^\/risk-assessments$/,
  /^\/risk-assessments\/new\/[^/]+$/,
  /^\/risk-assessments\/[^/]+\/[^/]+$/,
  /^\/risk-assessments\/[^/]+\/[^/]+\/edit$/,
  /^\/schedule$/,
  /^\/calendar$/,
  /^\/capacity$/,
  /^\/roster$/,
  /^\/timesheets$/,
  /^\/sessions\/[^/]+$/,
  /^\/incidents$/,
  /^\/incidents\/[^/]+$/,
  /^\/complaints$/,
  /^\/complaints\/[^/]+$/,
  /^\/registers$/,
  /^\/staff$/,
  /^\/staff\/[^/]+$/,
  /^\/rooms$/,
  /^\/assets$/,
  /^\/billing$/,
  /^\/checkout\/[^/]+$/,
  /^\/settings\/finance$/,
  /^\/settings\/booking-types$/,
  /^\/settings\/booking-types\/new$/,
  /^\/settings\/booking-types\/[^/]+$/,
  /^\/settings\/risk$/,
  /^\/settings\/organizations$/,
  /^\/settings\/organizations\/new$/,
  /^\/settings\/organizations\/[^/]+$/,
  /^\/settings\/system$/,
  /^\/organisations$/,
  /^\/organizations$/,
]

function isExcludedRoute(path: string): boolean {
  if (EXACT_EXCLUDED.has(path)) return true
  return EXCLUDED_PREFIXES.some((prefix) => path.startsWith(prefix))
}

function isKnownAppRoute(path: string): boolean {
  return KNOWN_ROUTE_PATTERNS.some((re) => re.test(path))
}

export function saveLastRoute(path: string): void {
  if (!path || isExcludedRoute(path)) return
  try {
    localStorage.setItem(LAST_ROUTE_KEY, path)
  } catch {
    // ignore
  }
}

function getLastRoute(): string | null {
  try {
    return localStorage.getItem(LAST_ROUTE_KEY)
  } catch {
    return null
  }
}

/**
 * Post-login destination: state.from → saved last route → role landing → /.
 */
export function resolvePostLoginPath(
  from: string | undefined | null,
  roles?: string[] | null,
): string {
  if (from && isKnownAppRoute(from)) return from
  const saved = getLastRoute()
  if (saved && isKnownAppRoute(saved)) return saved
  if (roles?.length) return resolveLandingRoute(roles)
  return '/'
}
